import React, { useState } from 'react'
import '../../assets/styles/distributors.css';
import '../../assets/styles/createproduct.css';
import { useQueryClient } from '@tanstack/react-query';
import { useViewNottificationsList } from '../../hooks/nottifications/nottifications.list';
import { useNottificationSend } from "../../hooks/nottifications/nottificaiton"
import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

const PushNotification = () => {
  const queryClient = useQueryClient();
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [notificationData, setNotificationData] = useState([]);
  const [endDate, setEndDate] = useState('');
  const { data: notifications, isLoading, error } = useViewNottificationsList();
  const sendNotification = useNottificationSend();

  useEffect(() => {
    if (notifications) {
      console.log(notifications);
      setNotificationData(notifications.data);
    }
  }, [notifications]);


  const formatedDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-GB", {
    });
  };

  console.log(notificationData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      title: title?.trim(),
      body: message?.trim(),
    };

    if (!payload.title || !payload.body) {
      toast.error("Please enter both title and message.");
      return;
    }

    try {
      await sendNotification.mutateAsync(payload);
      toast.success("Notification sent.");
      setTitle("");
      setMessage("");
      queryClient.invalidateQueries({ queryKey: ["viewNottificationsList"] });
    } catch (err) {
      toast.error("Failed to send notification.");
      console.error("Failed to send notification", err);
    }
  };

  console.log(notifications);
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  return (
    <>
      <div className="body">
        <div className="inputFields">
          <form onSubmit={handleSubmit}>
            <div className="form-header" style={{ display: "flex", gap: "20px", alignItems: "flex-start", flexWrap: "wrap" }}>
              <div className="text-inputs" style={{
                flex: 1,
                minWidth: 0,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}>
                <div>
                  <label htmlFor="title">Title</label>
                  <input
                    type="text"
                    id="title"
                    name="title"
                    placeholder="Enter notification title..."
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    style={{ width: "100%", marginTop: "10px" }}
                  />
                </div>

                <div>
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    placeholder="Enter notification message..."
                    value={message}
                    name='body'
                    onChange={(e) => setMessage(e.target.value)}
                    style={{ width: "100%", marginTop: "10px", minHeight: "100px", padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                  />
                </div>

              </div>
            </div>
          </form>
        </div>

        <div style={{
          display: "flex",
          gap: "10px",
          justifyContent: "flex-end",
          marginTop: "20px",
          marginBottom: "20px",
        }}>
          <button
            className="cancelBtn"
            type="button"
            onClick={() => {
              setTitle("");
              setMessage("");
              setStartDate("");
              setEndDate("");
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            type="submit"
            className="commonButton"
            disabled={sendNotification.isPending}
          >
            {sendNotification.isPending ? "Sending..." : "Send Notification"}
          </button>
        </div>
      </div>

      <div className="distributor-list-container">
        <div className="distributor-table-container">
          <table className="distributor-table">
            <thead>
              <tr className="distributor-table-head-tr">
                <th className="distributor-th">ID</th>
                <th className="distributor-th">Title Name</th>
                <th className="distributor-th">CreatedAt</th>
                <th className="distributor-th">Status</th>
              </tr>
            </thead>
            <tbody>
              {notificationData.map((notification, index) => (
                <tr key={index} className="distributor-tr">
                  <td className="distributor-th">{notification._id}</td>
                  <td className="distributor-th">{notification.title}</td>
                  <td className="distributor-th"> {formatedDate(notification.createdAt)}</td>
                  <td
                    className="distributor-th"
                    style={{
                      color:
                        notification.status === "sent"
                          ? "green"
                          : notification.status === "failed"
                            ? "red"
                            : "black",
                      fontWeight: "bold",
                    }}
                  >{notification.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default PushNotification;

